/**
 * Universal Ribbon Banner - Discount Code Functionality
 * Works on any Shopify theme
 */

(function() {
  'use strict';
  
  // Initialize all discount codes on the page
  function initDiscountCodes() {
    const discountBoxes = document.querySelectorAll('.ribbon-discount');
    
    discountBoxes.forEach(function(discountEl) {
      const input = discountEl.querySelector('.discount-input');
      const copyBtn = discountEl.querySelector('.discount-copy-btn');
      const box = discountEl.querySelector('.discount-box');
      
      if (!input || !copyBtn) return;
      
      // Click on input to select
      input.addEventListener('click', function() {
        this.select();
      });
      
      // Copy button click
      copyBtn.addEventListener('click', function() {
        copyDiscountCode(input, copyBtn, box);
      });
      
      // Also allow clicking the whole discount box
      discountEl.addEventListener('click', function(e) {
        if (e.target !== copyBtn && !copyBtn.contains(e.target)) {
          copyDiscountCode(input, copyBtn, box);
        }
      });
    });
  }
  
  // Copy discount code to clipboard
  function copyDiscountCode(input, button, box) {
    const code = input.value;
    const originalText = button.textContent;
    
    // Check if in Shopify design mode
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      alert('The Theme Editor restricts clipboard access. Please test in preview mode.');
      return;
    }
    
    // Try modern clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code)
        .then(function() {
          showCopySuccess(button, box, originalText);
        })
        .catch(function() {
          // Fallback to execCommand
          fallbackCopy(input, button, box, originalText);
        });
    } else {
      // Fallback for older browsers
      fallbackCopy(input, button, box, originalText);
    }
  }
  
  // Fallback copy method
  function fallbackCopy(input, button, box, originalText) {
    try {
      input.select();
      input.setSelectionRange(0, 99999); // For mobile
      document.execCommand('copy');
      showCopySuccess(button, box, originalText);
    } catch (err) {
      alert('Could not copy code. Please copy manually: ' + input.value);
    }
  }
  
  // Show success feedback
  function showCopySuccess(button, box, originalText) {
    // Change button state
    button.classList.add('copied');
    button.textContent = '✓ Copied!';
    
    // Remove glow animation temporarily
    if (box) {
      box.classList.remove('discount-box-animated');
      
      // Add scale animation
      box.style.transform = 'scale(1.05)';
      setTimeout(function() {
        box.style.transform = 'scale(1)';
      }, 200);
    }
    
    // Reset after 2 seconds
    setTimeout(function() {
      button.classList.remove('copied');
      button.textContent = originalText;
      
      if (box) {
        box.classList.add('discount-box-animated');
      }
    }, 2000);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountCodes);
  } else {
    initDiscountCodes();
  }
  
  // Re-initialize on Shopify section events
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', initDiscountCodes);
    document.addEventListener('shopify:section:reorder', initDiscountCodes);
  }
  
})();
